import React, { useState, useEffect } from 'react';

let userInfo = JSON.parse(localStorage.getItem('user_info'));
const MyContext = React.createContext({
    data: null, // Initial state for data
    loading: false, // Initial state for loading indicator
    error: null, // Initial state for error handling
    userInfo: userInfo,
    t: () => {}
});

export { HRMProvider, useHRM } from './HrmContext';

export default MyContext;
